import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Switch,
  FormControlLabel,
  Typography,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

import "../../../App.css";
import SearchBar from "../../SearchBar";
import { postResource } from "../../../apis/apiService";
import { toast } from "react-toastify";
import { useFetchAddportalUserQuery, useFetchClientsShowUsersQuery,} from "../../../slice/logdetailSlice";
import { useTheme } from "../../../ThemeContext";
const ClientAddUser = ({ onCancel, onApply, onClear, showClients }) => {
  const [search, setSearch] = useState("");
  const [roleFilter, setRoleFilter] = useState("All Roles");
  const [profileFilter, setProfileFilter] = useState("All Roles");
  const [selectedUsers, setSelectedUsers] = useState([]); // To keep track of selected users
  const [checked, setChecked] = useState(true);
  const [loading, setLoading] = useState(false);
  const { isDarkMode } = useTheme();
  const project_id = localStorage.getItem("project_id");
  // const portalClientOptons = useSelector(
  //   (state) => state.selectOptions.PortalClients
  // );

  const { data, refetch } = useFetchClientsShowUsersQuery(project_id);
  const { data: portalClientOptons, refetch: client_refetch } =
    useFetchAddportalUserQuery({
      id: project_id,
      type: "client",
    });
  // //console.log()("portalClientOptons", portalClientOptons);

  const userDetails = portalClientOptons
    ?.map((user) => {
      if (!user || !user.user_name) {
        console.warn("Invalid user data:", user);
        return null; // Skip invalid users
      }
      // //console.log()("user_list_name_in_client:", user.user_name);

      return {
        user_id: user.user_id,
        user_name: user.user_name.trim() || "N/A", // Replace empty names with 'N/A'
        email: user.email,
        designation: user.designation,
        role: user.role,
        image_url: user.image_url,
        rate_per_hour: user.rate_per_hour,
      };
    })
    .filter(Boolean); // Remove null values from the array

  // //console.log()("user_detail :", userDetails);

  const filteredUsers = userDetails?.filter(
    (user) =>
      user.user_name.toLowerCase().includes(search.toLowerCase()) ||
      user.email.toLowerCase().includes(search.toLowerCase())
  );

  // Handle selection of users
  const handleUserSelect = (user, isSelected) => {
    // //console.log()("add_client : ", user, "selected :", isSelected);

    if (isSelected) {
      setSelectedUsers((prev) => [...prev, user]);
    } 
    else {
      setSelectedUsers((prev) => prev.filter((u) => u !== user));
    }
  };

  // Handle Add button click
  const handleAddClick = async () => {
    const requestedData = {
      user_ids: selectedUsers,
      notify_user: checked,
    };
    setLoading(true);
    try {
      const response = await postResource(
        "projects/client",
        "add",
        project_id,
        requestedData
      );
      // // //console.log()("add_client response :", response);
      // await showClients();
      refetch();
      // // //console.log()("client_show_users_response in response :", refetch());

      if (response) {
        // //console.log()(" add_client Fetching portal users : ", response);
        toast.success(response.message);
        onCancel();
        client_refetch();
        // const client = await showClients();
        // // //console.log()("showClients_api", client);
      }
    } 
    catch (error) {
      console.error("Error adding users to project:", error);
      toast.error(error.message);
    } 
    finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        padding: 2,
        backgroundColor: isDarkMode ? "#121212" : "#F9FAFC",
        height: "100%",
      }}
    >
      {/* Filters */}
      <Box
        sx={{
          backgroundColor: isDarkMode ? "#1e1e1e" : "white",
          padding: 2,
          borderRadius: 1,
          marginBottom: 2,
        }}
      >
        {/* Search Bar */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            marginBottom: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
              borderRadius: 1,
              paddingX: 1,
            }}
          >
            <SearchBar
              placeholder="Search client name "
              onSearchChange={(e) => setSearch(e.target.value)}
            />
          </Box>
        </Box>

        {/* Table */}
        <TableContainer
          component={Paper}
          className="tableScroll"
          sx={{
            backgroundColor: isDarkMode ? "#1e1e1e" : "white",
          }}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    position: "sticky",
                    left: 0,
                    backgroundColor: isDarkMode ? "#1e1e1e" : "white",
                    color: isDarkMode ? "#fff" : "#000",
                    zIndex: 12,
                    minWidth: 100,
                    fontWeight: 500,
                    fontSize: 15,
                  }}
                >
                  Action
                </TableCell>
                <TableCell
                  sx={{
                    position: "sticky",
                    left: 100,
                    backgroundColor: isDarkMode ? "#1e1e1e" : "white",
                    color: isDarkMode ? "#fff" : "#000",
                    zIndex: 13,
                    minWidth: 250,
                    fontWeight: 500,
                    fontSize: 15,
                  }}
                >
                  Client Name
                </TableCell>
                <TableCell
                  sx={{
                    minWidth: 150,
                    fontWeight: 500,
                    fontSize: 15,
                    backgroundColor: isDarkMode ? "#1e1e1e" : "white",
                    color: isDarkMode ? "#fff" : "#000",
                  }}
                >
                  Email
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {filteredUsers?.length > 0 ? (
                filteredUsers.map((user, index) => (
                  <TableRow key={index}>
                    <TableCell
                      sx={{
                        position: "sticky",
                        left: 0,
                        backgroundColor: isDarkMode ? "#1e1e1e" : "white",
                        zIndex: 1,
                      }}
                    >
                      <Checkbox
                        sx={{ color: "#CDCDCD" }}
                        onChange={(e) =>
                          handleUserSelect(user.user_id, e.target.checked)
                        }
                      />
                    </TableCell>

                    <TableCell
                      sx={{
                        position: "sticky",
                        left: 100,
                        backgroundColor: isDarkMode ? "#1e1e1e" : "white",
                        zIndex: 1,
                      }}
                    >
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: 500,
                          fontSize: 15,
                          color: isDarkMode ? "#fff" : "#000",
                        }}
                      >
                        {user.user_name}
                      </Typography>
                    </TableCell>

                    <TableCell
                      sx={{
                        color: isDarkMode ? "#ccc" : "#626161",
                        fontSize: 15,
                      }}
                    >
                      {user.email}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableCell colSpan={6}>
                  <p
                    className="text-center"
                    style={{ color: isDarkMode ? "#bbb" : "#000" }}
                  >
                    Client not found
                  </p>
                </TableCell>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      {/* Add and Cancel Buttons */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          gap: "20px",
          padding: " 16px 30px",
          backgroundColor: isDarkMode ? "#1e1e1e" : "#f9f9f9",
          borderTop: "1px solid #ddd",
          position: "absolute",
          bottom: -10,
          width: "100%",
          zIndex: 100,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <button
            className="add_btn"
            onClick={handleAddClick}
            disabled={selectedUsers.length === 0 || loading}
          >
            {loading ? "Adding..." : "Add"}
          </button>

          <button
            className="cancel_btn  mx-3"
            disabled={loading}
            onClick={onCancel}
          >
            Cancel
          </button>
        </Box>
        
        <Box>
          <FormControlLabel
            control={
              <Switch
                checked={checked}
                onChange={(e) => setChecked(e.target.checked)}
              />
            }
          />
        </Box>
      </Box>
    </Box>
  );
};

export default ClientAddUser;
